<template lang="pug">
.home
  v-content.home__bg-wrap
    v-container(
      justify-center
      align-center
      fluid)
      v-layout(column align-center)
        v-avatar.my-4(
          tile
          size="128"
          color="white")
          img(:src="logo")
        h1.headline.font-weight-black.grey--text.text--darken-2.py-5 歡迎來到桃園市屏東同鄉會
        v-card(
          color="info"
          elevation="18"
          width="100%"
          max-width="400")
          v-card-title.subheading.white--text.font-weight-bold {{ welcomeMessage }}
          v-card-text
            v-container.pa-0
              v-layout(column)
                //v-btn(
                  :to="{ name: 'report' }"
                  color="white"
                  outline
                  large) 一般會員繳費資料登錄
                v-btn(
                  v-if="!isSignIn"
                  color="white"
                  outline
                  large
                  @click="openLogin") 幹部登入
                v-btn(
                  v-if="isSignIn && role"
                  :to="{ name: 'admin' }"
                  color="white"
                  outline
                  large) 進入管理系統
                v-btn(
                  v-if="isSignIn"
                  color="white"
                  outline
                  large
                  @click="signOut") 登出
                v-btn(
                  color="white"
                  outline
                  large
                  href="https://typt.org") 回到官網
    login-modal(ref="loginModal")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginModal from "@/components/LoginModal.vue";
import logo from "@/assets/images/logo.png";

export default {
  name: "home",
  components: {
    LoginModal
  },
  data() {
    return {
      logo
    };
  },
  computed: {
    ...mapGetters("auth", ["isSignIn", "role", "profile"]),
    welcomeMessage() {
      const displayName = this.profile ? this.profile.displayName : "訪客";
      return `親愛的${displayName}您好`;
    }
  },
  methods: {
    ...mapActions("auth", ["onAuth", "signOut"]),
    openLogin() {
      this.$refs.loginModal.open();
    }
  }
};
</script>
<style lang="styl">
.home
  &__bg-wrap
    height 100vh
</style>
